/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { $Q } from './query-selector';

/**
 * The function shows or hides a button based on the number of line breaks in a given element and
 * toggles the visibility of the element when the button is clicked.
 * @param saltos - It is unclear what `saltos` represents without more context. It is likely a variable
 * or parameter that is being passed into the `showOrHideButton` function, but its purpose is unknown
 * without further information.
 * @param elemento - It is a variable representing an HTML element that needs to be shown or hidden
 * based on the number of "saltos" (jumps or lines of text) it contains.
 * @param button - The `button` parameter is a reference to a DOM element that represents a button.
 */
const showOrHideButton = (saltos, elemento, button) => {
  const excerptNumber = window.innerWidth >= 1024 ? 10 : 6;

  if (saltos > excerptNumber) {
    button.classList.remove('hidden');

    button.addEventListener('click', () => {
      const { dataset: { more, minus, state } } = button;
      let message = more;
      if (state === "true") {
        elemento.classList.add('show');
        message = minus;
        button.dataset.state = "false";
      } else {
        elemento.classList.remove('show');
        button.dataset.state = "true";
      }
      button.innerHTML = message;
    });
  }
}

/**
 * The function calculates the number of line breaks needed for a given text element and shows or hides
 * a button accordingly.
 * @param elemento - an HTML element that contains text content.
 * @param button - The `button` parameter is a reference to a button element that will be shown or
 * hidden based on the number of line breaks in the `elemento` parameter.
 */
const contarSaltosDeLinea = (elemento, button) => {
  const anchoElemento = elemento.offsetWidth;
  const estiloOriginal = elemento.getAttribute('style');

  elemento.style.whiteSpace = 'nowrap';
  elemento.style.display = 'inline';

  const lineHeight = parseInt(window.getComputedStyle(elemento).lineHeight, 10);
  const anchoTexto = (((elemento.offsetWidth / anchoElemento) * lineHeight) + elemento.offsetWidth);
  const saltosDeLinea = Math.ceil(anchoTexto / anchoElemento);

  elemento.style.whiteSpace = '';
  elemento.style.display = estiloOriginal;

  showOrHideButton(saltosDeLinea, elemento, button);
}

/**
 * The function initializes a "see more" button for a container's description paragraph and counts the
 * number of line breaks in the paragraph.
 */
export const initSeeMore = () => {
  const seeMoreElement = $Q('.container__description-paragraph');
  const buttonSeeMore = $Q('.container__description-more');

  if (!seeMoreElement || !buttonSeeMore) {
    return;
  }

  contarSaltosDeLinea(seeMoreElement, buttonSeeMore);
}
